export const APPOINTMENT_EXAMS = Object.freeze([
  'Ecocardiografia (Adulto)', 'Ecocardiografia Pediátrica', 'Ecocardiografia de Stress',
  'Doppler Colorido Vascular', 'Medicina Nuclear', 'Teste Ergométrico',
  'Ultrassonografia Abdominal', 'Ultrassonografia Pélvica', 'Ultrassonografia Obstétrica',
  'Holter 24h', 'MAPA', 'Eletrocardiograma', 'Cintilografia', 'Outro',
]);

export const APPOINTMENT_CONVENIOS = Object.freeze([
  'Particular', 'Unimed', 'Ipasgo', 'Bradesco Saúde', 'GEAP', 'CASSI',
  'Caixa (Saúde Caixa)', 'Itaú/Fundação Saúde Itaú', 'SulAmérica', 'Amil',
  'Affego', 'CONAB', 'Fusex', 'MedPrev', 'PostalSaúde', 'SAMP', 'Outro',
]);

export function getAppointmentExam(search = '') {
  const params = new URLSearchParams(search);
  return String(params.get('exame') || '').trim();
}

export function getAppointmentExamOptions(selectedExam = '') {
  const exam = String(selectedExam || '').trim();
  if (!exam || APPOINTMENT_EXAMS.includes(exam)) return [...APPOINTMENT_EXAMS];
  return [exam, ...APPOINTMENT_EXAMS];
}
